import { T } from '@app/components/translation';

export const SubscriptionCancelationRequestEvent = () => (
  <T
    _str="Subscription Plan was requested to be canceled"
    _comment="Audit log event message for a subscription cancelation request"
  />
);
